import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { colors } from 'theme/colors';

export const InfoBox = styled(Grid)`
  flex-wrap: nowrap;
  align-items: center;
  padding: 8px;
  gap: 16px;
  border-radius: 4px;
  border: 1px solid ${colors.blue600};
  p {
    font-weight: 600;
    color: ${colors.blue600};
  }
`;
